import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import Routes from "../../../../../navigation/route/Route";
import * as classNames from "classnames";
import BillCreatedNotification from "../../../../../model/notification/invoice/BillCreatedNotification";
import BillPaidNotification from "../../../../../model/notification/invoice/BillPaidNotification";

interface IComponentProps {
	/**
	 * Notification for display.
	 */
	notification: BillPaidNotification;
	/**
	 * Mark notification as read.
	 */
	markReadNotification: (notificationId: string) => void;

	/**
	 * Mark notification as unread.
	 */
	markUnreadNotification: (notificationId: string) => void;
}

type Props = IComponentProps & RouteComponentProps<IComponentProps>;

class NotificationBillCreatedItem extends React.PureComponent<Props> {

	render() {

		const classFromProps = classNames({
			"c-notification": true,
			"active": !this.props.notification.read
		});

		return (
			<div className={classFromProps}>
				<div className={"notification-icon"}>
					<img src="/assets/img/icons/icon-noti-reminder.svg"/>
				</div>
				<div className={"notification-body"}>
					<div className={"notification-header"}>
						Bill {this.props.notification.data.jobRefNumber} &middot;
						Bill has been paid
					</div>
					<div className={"notification-content"}>
						{this.props.notification.displayDate()}
					</div>
					<span className="notification-link" onClick={this.routeToBill}>View</span>
					<span className="notification-link-separator">|</span>
					{this.renderNotificationActions()}
				</div>
			</div>
		);
	}

	/**
	 * Render notification actions.
	 */
	renderNotificationActions() {
		if (this.props.notification.read) {
			return <span className="notification-link"
						 onClick={() => this.props.markUnreadNotification(this.props.notification.id)}>Mark as Unread</span>;
		}
		return <span className="notification-link" onClick={() => this.props.markReadNotification(this.props.notification.id)}>Mark as Read</span>;
	}

	/**
	 * Route to bill.
	 */
	routeToBill = () => {
		this.props.history.push(Routes.BillDetailsView(this.props.notification.data.billId));
	}
}

export default withRouter<IComponentProps>(NotificationBillCreatedItem);
